import { gql } from '@apollo/client'
import { NARRATIVE_FRAGMENT } from 'apollo/fragments/Narrative'

export const GET_NARRATIVES = gql`
  query GetNarratives {
    getNarratives {
      ...NarrativeFragment
    }
  }
  ${NARRATIVE_FRAGMENT}
`
